import { SelectizeSettings } from 'assets/js/SelectizePlugin-InfiniteScroll';

angular.module('logbook').directive('mdcKeypairSelector', ['$q', '$timeout', '$http', function($q, $timeout, $http)
{
	return {
		
		restrict: 'E',
		template: require('./mdc-keypair-selector.html'),
		scope: {
			selectedLog: '=',
			alert: '=',
			mdc: '='
		},
		
		link: {
			
			pre: function(scope, element, attr)
			{
				scope.parameterKeyPairs = [];
				scope.selectedPairs = [];
				
				scope.filtering = {
					//ID of parameter
					parameter: undefined,
					selectizeSettings: new SelectizeSettings(),
					constraintEnabled: false,
					currentFilter: undefined,
					operator: '1',
					filters: [],
					
					watch: function(){ return scope.filtering.selectizeSettings },
					addFilter: function()
					{
						if (!this.constraintEnabled || typeof this.currentFilter !== "function") return;
						var parameter = scope.alert.getParameterById(scope.filtering.parameter);
						this.filters.push({
							parameter: parameter,
							description: parameter.name + (this.operator === '1' ? ' is ' : ' is not ') + scope.filtering.cValue,
							filter: this.currentFilter
						});
						
						this.clearFilter();
					},
					removeFilter: function(filter)
					{
						var index = scope.filtering.filters.findIndex(function(f){ return f.filter === filter });
						scope.filtering.filters.splice(index, 1);
						return scope.filtering.filters;
					},
					clearFilter: function()
					{
						this.parameter = undefined;
						if (this.selectizeSettings)
							this.selectizeSettings.instances.forEach(function(instance){ instance.instance.destroy(); });
						this.update();
					},
					getAvailableParameters: function()
					{
						return scope.alert.parameters.filter(function(param)
						{
							return param.key && !scope.filtering.filters.some(function(filter){ return filter.parameter === param })
						})
					},
					update: function()
					{
						var filterSettings = scope.filtering;
						
						var parameter = scope.alert.getParameterById(filterSettings.parameter);
						var constraint = undefined;
						filterSettings.currentFilter = undefined;
						if (!parameter || !(constraint = parameter.getTagConstraint() || parameter.getListConstraint()))
						{
							filterSettings.constraintEnabled = false;
							filterSettings.selectizeSettings = undefined;
							return;
						}
						filterSettings.constraintEnabled = true;
						var entityType = constraint.tag ? 'tagValues' : 'choiceListItems';
						var queryField = 'matches';
						var labelField = entityType === 'tagValues' ? 'viewString' : 'value';
						
						var settings = new SelectizeSettings(entityType, queryField, labelField, labelField)
							.useLog(entityType === 'tagValues');
						
						if (entityType === 'choiceListItems')
							settings.addUrlParameter('listId', constraint.id);
						
						settings.setOnChange(function(newVal)
						{
							filterSettings.currentFilter = function(pair)
							{
								return Object.keys(pair).some(function(key)
								{
									return key === parameter.name && (filterSettings.operator === '1'
										? pair[key] === newVal
										: pair[key] !== newVal);
								});
							}
							scope.filtering.cValue = newVal;
							$timeout();
						});
						
						
						filterSettings.selectizeSettings = settings;
					}
				}
				
				scope.updateParameterKeyPairs = function()
				{
					var paramMap = { log: scope.selectedLog.id };
					var nameMap = {};
					scope.alert.parameters.forEach(function(/*AlertParameter*/ param, index)
					{
						index += 1;
						if (!param.key)
							return;
						
						paramMap['p' + index] = param.name;
						nameMap[param.name] = param;
						var constraint = param.getTagConstraint() || param.getListConstraint();
						if (constraint)
						{
							if (constraint.tag)
							{
								paramMap['tp' + index] = constraint.tag.id;
								if (constraint.depth)
									paramMap['td' + index] = constraint.depth;
							}
							else
							{
								paramMap['cl' + index] = constraint.id;
							}
						}
					})
					
					$http.get('/api/alertParameterValueCombinations', {
						params: paramMap
					})
						.then(function(results)
						{
							var filtered = results.data.filter(function(pairs)
							{
								return !Object.keys(pairs).every(function(key, index)
								{
									return scope.selectedPairs.some(function(sPairs)
									{
										return sPairs[key] == pairs[key];
									})
								});
							})
							scope.parameterKeyPairs = filtered;
						})
				}
				
				/**
				 * @return {T[]}
				 */
				scope.getFiltered = function()
				{
					var filters = scope.filtering.filters.map(function(obj){ return obj.filter });
					
					filters.push(function(pair){ return !pair.selected });
					
					if (typeof scope.filtering.currentFilter === 'function')
						filters.push(scope.filtering.currentFilter);
					
					return filters.reduce(function(arr, filter)
					{
						return arr.filter(filter);
					}, scope.parameterKeyPairs)
					
				}
				
				scope.selectAllConstraints = function()
				{
					scope.getFiltered().forEach(function(pairs)
					{
						scope.selectConstraint(pairs);
					})
					return scope.selectedPairs;
				}
				
				scope.unSelectAllConstraints = function()
				{
					scope.parameterKeyPairs = scope.parameterKeyPairs.concat(scope.selectedPairs.splice(0));
					return scope.selectedPairs;
				}
				
				scope.selectConstraint = function(pairs)
				{
					var index = scope.parameterKeyPairs.indexOf(pairs);
					scope.selectedPairs = scope.selectedPairs.concat(scope.parameterKeyPairs.splice(index, 1));
					return scope.selectedPairs;
				}
				
				scope.unSelectConstraint = function(pairs)
				{
					var index = scope.selectedPairs.indexOf(pairs);
					scope.parameterKeyPairs = scope.parameterKeyPairs.concat(scope.selectedPairs.splice(index, 1));
					return scope.selectedPairs;
				}
				
				scope.prepForSave = function(base)
				{
					base.alertInstanceSpecifications = scope.selectedPairs.reduce(function(map, pairs, index)
					{
						delete pairs.$$hashKey;
						Object.keys(pairs).forEach(function(key)
						{
							map[index + ',' + key] = pairs[key];
						})
						return map;
					}, {});
				}
				
				scope.showSetupModal = function(isShowing)
				{
					var command = (typeof isShowing === 'boolean') ? !!isShowing ? 'show' : 'hide' : 'toggle'
					$(element).find('.modal').modal(command);
					scope.filtering.clearFilter();
					scope.filtering.filters.splice(0);
				}
				
				var initialSetup = false;
				scope.$watchCollection(function(){ return scope.alert.parameters; }, function(newVal)
				{
					if (newVal === undefined)
						return;
					scope.updateParameterKeyPairs();
					if (initialSetup)
						scope.selectedPairs.splice(0);
					initialSetup = true;
				})
				
				scope.mdc.addOnSaveCustomizer(scope.prepForSave);
				
				var spec = Object.values(Object.keys(scope.mdc.alertInstanceSpecifications).reduce(function(keyMap, key)
				{
					var split = key.split(',');
					var value = scope.mdc.alertInstanceSpecifications[key];
					var mapKey = split[0];
					key = split[1];
					
					var mapEntry = keyMap[mapKey] || {};
					mapEntry[key] = value;
					keyMap[mapKey] = mapEntry;
					return keyMap;
				}, {}))
					.reduce(function(arr, mapEntry)
					{
						function findParamIndex(name)
						{
							return scope.alert.parameters.findIndex(function(param){ return param.name === name; })
						}
						
						// Sort based on alert parameter ordering
						mapEntry = Object.keys(mapEntry).sort(function(key1, key2)
							{
								var p1 = findParamIndex(key1);
								var p2 = findParamIndex(key2);
								
								return p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
							})
							.reduce(function(map, key)
							{
								map[key] = mapEntry[key];
								return map
							}, {})
						
						arr.push(mapEntry);
						return arr;
					}, [])
				
				scope.selectedPairs = scope.selectedPairs.concat(spec);
				
				$timeout(function()
				{
					scope.filtering.clearFilter();
				})
			}
			
		}
	}
}])